import { Flex, Text, useMediaQuery, useTheme } from '@chakra-ui/react';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { User as UserIcon } from '../../../../context/Chakra/Icons';
import {
  BOOLEAN_STATUS,
  GENERAL_FIELD_TYPE,
} from '../../../../../constants/userSetting';
import { useAppContext } from '../../../context/appContext';
import BindingAccount from '../components/BindingAccount';
import BirthdayPicker from '../components/BirthdayPicker';
import CustomFieldInput from '../components/CustomFieldInput';
import EmailField from '../components/EmailField';
import GenderSelector from '../components/GenderSelector';
import Message from '../components/Message';
import MobilePhoneField from '../components/MobilePhoneField';
import NameField from '../components/NameField';
import PasswordField from '../components/PasswordField';
import { useProfileContext } from '../context/profileContext';

const MemberDataSection = () => {
  const { t } = useTranslation();
  const { userSetting } = useAppContext();
  const { userData } = useProfileContext();
  const theme = useTheme();
  const [isDesktop] = useMediaQuery(`(min-width: ${theme.breakpoints.md})`);

  const generalFields = useMemo(
    () =>
      (userSetting?.general_fields || []).filter(
        (field) => field.options.profile.include === BOOLEAN_STATUS.TRUE,
      ),
    [userSetting?.general_fields],
  );

  const customFields = useMemo(
    () =>
      (userSetting?.custom_fields || []).filter(
        (field) => field.options.profile.include === BOOLEAN_STATUS.TRUE,
      ),
    [userSetting?.custom_fields],
  );

  return (
    <Flex
      direction="column"
      gap="20px"
      padding="20px 20px 40px"
      border="1px solid #dddddd"
      w={isDesktop ? '50%' : '100%'}
      className="member-center-profile__form-section"
    >
      <Message />
      <Flex
        gap="10px"
        className="member-center-profile-section_title"
        alignItems="center"
      >
        <UserIcon
          fontSize="20px"
          color="#dddddd"
          className="icon-user member-center-profile__section-title-icon"
        />
        <Text
          variant="sectionTitle"
          className="member-center-profile__section-title-text"
        >
          {t('member_profile.profile')}
        </Text>
      </Flex>
      <NameField />
      <EmailField />
      <MobilePhoneField />
      {generalFields.map((field) => {
        switch (field.type) {
          case GENERAL_FIELD_TYPE.GENDER:
            return (
              <GenderSelector
                key={field.type}
                required={
                  field.options.profile.required === BOOLEAN_STATUS.TRUE
                }
              />
            );
          case GENERAL_FIELD_TYPE.BIRTHDAY:
            return (
              <BirthdayPicker
                key={field.type}
                required={
                  field.options.profile.required === BOOLEAN_STATUS.TRUE
                }
              />
            );
          default:
            return <React.Fragment key={field.type}></React.Fragment>;
        }
      })}
      {customFields?.map((field) => {
        if (field.column_type === 'readable') {
          return (
            <p key={field.field_id}>{userData.custom_data[field.field_id]}</p>
          );
        }

        return (
          <CustomFieldInput
            key={field.field_id}
            required={field.options.profile.required === BOOLEAN_STATUS.TRUE}
            {...field}
          />
        );
      })}
      <PasswordField />
      <BindingAccount />
    </Flex>
  );
};

export default MemberDataSection;
